import { getFirstPoolId } from "@/modules/charging-pool/utils/getFirstPoolId";
import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

type PoolSearch = {
	ids: string;
};

export const Route = createFileRoute("/pool")({
	validateSearch: (search: Record<string, unknown>): PoolSearch => ({
		ids: typeof search.ids === "string" ? search.ids : "",
	}),
	beforeLoad: ({ search }) => {
		const evseId = getFirstPoolId(search.ids);

		if (!evseId) {
			throw notFound();
		}

		throw redirect({ to: "/qrs/$evseId", params: { evseId } });
	},
	notFoundComponent: NotFoundPage,
	component: () => null,
});
